// Chip: a passive badge with a tone. Never a button — use `button.cf-chip` if
// it is meant to be tapped.

import { h } from '../dom';

export type ChipTone = 'plain' | 'good' | 'warn' | 'danger' | 'shade' | 'ink';

export interface ChipOptions {
  text: string;
  tone?: ChipTone;
  /** Small padding, for a tag sitting on a breed row. */
  compact?: boolean;
}

export function chip(options: ChipOptions): HTMLSpanElement {
  const tone = options.tone && options.tone !== 'plain' ? ` cf-chip--${options.tone}` : '';
  const compact = options.compact ? ' cf-chip--compact' : '';
  return h('span', { class: `cf-chip${tone}${compact}`, text: options.text });
}
